<template>
	<div id="app">
		<Header/>
		<router-view v-if="loaded"></router-view>
		<div class="loading-effect py-5 text-center" v-if="!loaded">
			<div class="spinner-border text-black-50 opacity-25"></div>
		</div>
	</div>
</template>

<script>
import Header from "@/components/Header";
import repository from "@/repository/repository";

export default {
    name: 'App',
    components: {
        Header,
    },
	data() {
        return {
            loaded: false,
		}
	},
	created() {
		// Check if there is a user already authenticated
        if(this.$store.getters.token) {
            // Verify if user is already signed in
            repository.get("/me")
                .then(response => {
                    this.$store.commit("updateAll", response.data.user);
                    this.$store.commit("setPreAuthenticated");
                    this.loaded = true;
                    if(this.$store.getters.review.finished) {
                        this.$router.replace("/already-completed");
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.$store.commit("logoutUser");
                    this.loaded = true;
                })
		} else {
            this.loaded = true;
        }

		// Initiate Intercom
		this.initiateIntercom();
    },
	methods: {
		initiateIntercom() {
			window.Intercom("boot", {
				api_base: "https://api-iam.intercom.io",
				app_id: "xf5uxpiq"
			});
		}
	}
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Red+Hat+Display:wght@400;500;600;700&display=swap");

html, body {
	font-family: "Red Hat Display", sans-serif;

	@media (min-width: 768px) and (max-width: 991px) {
		font-size: 14px;
	}
}

.form-field {
	.form-label {
		font-weight: bold;
		font-size: 1.15rem;
		margin: 0;
		display: block;
		user-select: none;

		@media (max-width: 767px) {
			font-size: 1rem;
		}
	}
	.form-control {
		border: none;
		border-bottom: 1px solid #ddd;
		border-radius: 0;
		padding: 0.25rem 0 0.75rem 0;
		font-size: 1.15rem;
		box-shadow: none;
		&:focus {
			box-shadow: none;
			border-bottom: 1px solid #F37021;
		}

		&[disabled] {
			background: inherit;
			cursor: default;
		}

		@media (max-width: 767px) {
			font-size: 1rem;
		}
	}
}

.form-check {
	&.button-checkbox {
		position: relative;
		padding: 0;
		margin: 0;

		.form-check-input {
			position: absolute;
			top: 0;
			left: 0;
			opacity: 0;

			&:checked ~ .form-check-label {
				background: #fdf0e8;
				border-color: #fdf0e8;
				color: #F37021;
			}
		}

		.form-check-label {
			padding: 0.75rem 5rem;
			border-radius: 0.5rem;
			background: #fff;
			border: 1px solid #ddd;
			font-size: 1.15rem;
			font-weight: 500;
			cursor: pointer;
			transition: 0.15s ease all;
			user-select: none;

			&:hover {
				background: #fafbfc;
				border-color: #fafbfc;
			}

			@media (min-width: 992px) and (max-width: 1199px) {
				padding: 0.75rem 2.5rem;
			}

			@media (min-width: 768px) and (max-width: 991px) {
				padding: 0.5rem 2.5rem;
			}

			@media (max-width: 767px) {
				font-size: 1rem;
				padding: 0.5rem 2.5rem;
			}
		}
	}

	&.rounded-checkbox {
		.form-check-label {
			border-radius: 3rem;
		}
	}
}

.btn {
	border-width: 2px !important;
    position: relative;

    .spinner-border {
		width: 1rem;
		height: 1rem;
		border-width: 2px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1;
        margin: auto;
	}

	&.btn-primary {
		padding: 0.75rem 2rem;
		font-size: 1.15rem;
		border-radius: 0.3rem;
		background: #F37021;
		border-color: #F37021;
		color: #fff;
		&:disabled {
			background: #F37021;
			border-color: #F37021;
		}
		&.btn-wide {
			padding: 0.75rem 4rem;
		}
		&:hover,
		&:focus {
			background: #144069;
			border-color: #144069;
		}
		&:active {
			background: #1c5a94;
			border-color: #1c5a94;
		}
	}
	&.btn-outline-primary {
		padding: 0.75rem 2rem;
		font-size: 1.15rem;
		border-radius: 0.3rem;
		background: transparent;
		border-color: #F37021;
		color: #F37021;
		&:disabled {
			background: #F37021;
			border-color: #F37021;
		}
		&.btn-wide {
			padding: 0.75rem 4rem;
		}
		&:hover,
		&:focus {
			background: #F37021;
			border-color: #F37021;
			color: #fff;
		}
		&:active {
			background: #1c5a94;
			border-color: #1c5a94;
		}
	}
	&.btn-secondary {
		padding: 0.75rem 2rem;
		font-size: 1.15rem;
		border-radius: 0.3rem;
		background: #16193A;
		border-color: #16193A;
		color: #fff;
		&:disabled {
			background: lighten(#16193A, 10%);
			border-color: lighten(#16193A, 10%);
		}
		&.btn-wide {
			padding: 0.75rem 4rem;
		}
		&:hover,
		&:focus {
			background: lighten(#16193A, 10%);
			border-color: lighten(#16193A, 10%);
		}
		&:active {
			background: lighten(#16193A, 15%);
			border-color: lighten(#16193A, 15%);
		}
	}
	&.btn-light {
		padding: 0.75rem 2rem;
		font-size: 1.15rem;
		border-radius: 0.3rem;
		background: #f2f3f4;
		border-color: #f2f3f4;
		color: #333;
	}
	&.btn-outline-dark {
		padding: 0.75rem 2rem;
		font-size: 1.15rem;
		border-radius: 0.3rem;
		background: #fff;
		border-color: #e1e2e3;
		color: #333;
		&:disabled {
			background: #fff;
			border-color: #e1e2e3;
			color: #333;
			opacity: 0.5;
		}
		&:hover,
		&:focus {
			background: #fafbfc;
			border-color: #fafbfc;
			color: #333;
		}
		&:active {
			background: #ddd;
			border-color: #ddd;
			color: #333;
		}
	}
	&:focus,
	&:active {
		box-shadow: rgba(10,10,10,0.1) 0 0.1rem 0.1rem !important;
	}
	&:active {
		transform-origin: center;
		transform: scale(0.975);
	}
}

.text-brand {
	color: #F37021 !important;
}
</style>
